import { Label } from "../../atoms/body-text";
import * as styles from "./styles.css";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Link } from "../../atoms/link";
export const HamburgerTabletMenuList = ({ title, src, altSrc, url, isSelected = false, onClickHamburgerList, }) => {
    const onItemClick = () => {
        onClickHamburgerList && onClickHamburgerList();
    };
    return (React.createElement(Link, { href: url },
        React.createElement("div", { className: styles.contentWrapper, onClick: onItemClick },
            isSelected ? altSrc : src,
            React.createElement("div", { className: styles.headerNavigationWeb, id: `#d${title}` },
                React.createElement(Label, { classNameM: M.of(styles.navigationTextDefaultWeb) },
                    React.createElement("div", { id: `#activeD${title}` }, title))))));
};

